export default __webpack_public_path__ + "static/media/bkg--home-2.957341b9.jpg";